<template>
  <div class="instock_device_dialog">
    <custom-dialog width="1180px" :title="model.title" :visible="visible" v-on="$listeners">
      <div class="dialog-body">
        <div class="item-title">{{ $t('dms_instock_device_dialog.shou_huo_xin_xi') }}</div>
        <div class="table-bd">
          <custom-table tableCode="confirmInstockRes" :data="selectData">
          </custom-table>
        </div>
        <div class="item-title" style="margin-top: 15px">{{ totalRowsTips }}</div>
        <div class="table-bd">
          <custom-table index tableCode="confirmInstock" :data="tableList" @filter="filterChange" @sort="sortChange"></custom-table>
        </div>
        <div class="table-page">
          <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="visible = false">{{ $t('Common.com_cancel') }}</el-button>
        <el-button type="primary" @click="confirm">{{ $t('Common.com_confirm')}}</el-button>
      </div>
    </custom-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';

export default {
  mixins: [dialogMixins],
  computed: {
    totalRowsTips() {
      return this.$t('dms_instock_device_dialog.shou_huo_she_beiotai', [this.totalRows]);
    }
  },
  data() {
    return {
      selectData: [],
      formSearch: {
        search: '',
        shipmentNum: '',
        pageSize: 50,
        pageNum: 1
      },
      tableList: [],
      totalRows: 0,
    };
  },
  mounted() {
    this.initDialog();
  },
  methods: {
    // 初始化
    initDialog: function () {
      this.formSearch.shipmentNum = this.model.row.shipmentNum;
      this.selectData = [this.model.row];
      this.getTableList();
    },
    // 获取表格数据列表
    getTableList: function () {
      this.$getJSON(apis.stockPendPage, this.formSearch).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    // 保存新增
    confirm: function () {
      this.$postJSON(`${apis.stockConfirmInStock}/${this.formSearch.shipmentNum}`).then(() => {
        this.$message({
          message: this.$t('Common.com_handle_success'),
          type: 'success'
        });
        this.$emit('success');
        this.clearKeepAlive('stockRecord');
        this.visible = false;

      });
    }
  }
};
</script>
